/** Legacy Trial Center placeholder; must not be sent to upstream e-stamp / liveness. */
export const TRIAL_CENTER_PLACEHOLDER_API_KEY = "g7ew9f-ew435-435";

const storageKey = (appId: string) => `trial_center_api_key_${appId}`;

export function saveTrialAppApiKey(appId: string, apiKey: string): void {
  const id = appId.trim();
  const key = apiKey.trim();
  if (!id || !key || key === TRIAL_CENTER_PLACEHOLDER_API_KEY) return;
  try {
    sessionStorage.setItem(storageKey(id), key);
  } catch {
    // ignore quota / private mode
  }
}

export function getTrialAppApiKey(appId: string): string | undefined {
  const id = appId.trim();
  if (!id) return undefined;
  try {
    const key = sessionStorage.getItem(storageKey(id))?.trim();
    if (!key || key === TRIAL_CENTER_PLACEHOLDER_API_KEY) return undefined;
    return key;
  } catch {
    return undefined;
  }
}

/** Headers for demo portal calls that require app-id + optional real api-key. */
export function trialDemoPortalHeaders(
  appId: string,
  orgId: string,
  xUserId: string,
  extra?: Record<string, string>
): Record<string, string> {
  const headers: Record<string, string> = {
    "app-id": appId,
    "org-id": orgId,
    "x-user-id": xUserId,
    ...extra,
  };
  const apiKey = getTrialAppApiKey(appId);
  if (apiKey) {
    headers["api-key"] = apiKey;
  }
  return headers;
}
